import React, { FC, memo } from 'react';
import styled from '@emotion/styled';
import Icon from '~ComponentsImproved/Icon';
import checkIcon from '../../../../Assets/icons/check.svg';

/**
 * Presentational checkbox: a rounded square that fills with a check when
 * checked. Like RadioButton, the row that contains it owns the tap - this
 * only shows the state. Use it wherever several options may be picked, so
 * the shape alone tells the shopper "you can take more than one".
 */
const Square = styled.span`
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  border-radius: 10px;
  border: 2px solid var(--eposBorderColor);
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  transition: border-color 0.15s ease-out, background-color 0.15s ease-out;

  &.is-checked {
    border-color: var(--eposButton);
    background: var(--eposButton);
  }
`;

const Mark = styled.span`
  display: inline-flex;
  transform: scale(0);
  transition: transform 0.15s cubic-bezier(0.22, 1, 0.36, 1);

  .is-checked & {
    transform: scale(1);
  }
`;

interface Props {
  checked: boolean;
  className?: string;
}

const CheckBox: FC<Props> = ({ checked, className }) => (
  <Square
    role="checkbox"
    aria-checked={checked}
    className={[className, checked && 'is-checked'].filter(Boolean).join(' ') || undefined}>
    <Mark>
      <Icon src={checkIcon} color="var(--eposButtonText)" width="20px" height="20px" />
    </Mark>
  </Square>
);

export default memo(CheckBox);
